import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import vuetify from './plugins/vuetify'
import store from './store/index.js'
import i18n from './localization/i18n'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import VueUploadComponent from 'vue-upload-component'
import VueLocalStorage from 'vue-localstorage'
import Snotify, {SnotifyPosition} from 'vue-snotify'
import './assets/snotify-material.css'
import VueCurrencyFilter from 'vue-currency-filter'
import VueShortKey from 'vue-shortkey'
import VueTheMask from 'vue-the-mask'

Vue.use(VueCurrencyFilter, {
    symbol: '₽',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
})

Vue.use(VueLocalStorage)
Vue.use(VueShortKey)
Vue.use(VueTheMask)
Vue.component('file-upload', VueUploadComponent)

const snotifyOptions = {
    toast: {
        position: SnotifyPosition.rightTop
    }
}

Vue.use(Snotify, snotifyOptions)
Vue.config.productionTip = false

async function init() {
    await store.dispatch('auth/getUserInfo')

    const app = new Vue({
        vuetify,
        store: store,
        router: router,
        localStorage: {
            clients: {
                type: Array
            }
        },
        i18n: i18n,
        render: h => h(App)
    }).$mount('#app')

    store.$app = app
}

init()
